import React, { FunctionComponent } from 'react';

import { darken } from 'polished';
import styled from 'styled-components';

import StyledGear from '@components/basics/icons/styled-gear';
import Typography from '@components/basics/typography';
import Flex from '@components/layout/flex';
import Avatar from '@components/basics/avatar';
import Box from '@components/layout/box';

interface ArtistSettingsWidgetProps {
  name?: string;
  avatar?: string;
  goToArtistSettings: (url: string) => void;
}

const ArtistSettingsWidget: FunctionComponent<ArtistSettingsWidgetProps> = ({
  name,
  avatar,
  goToArtistSettings,
}) => {
  return (
    <Box>
      <Flex alignItems="center" justifyContent="flex-start" gap={10}>
        <AvatarWrapper>
          <Avatar className="avatar" alt={name} src={avatar} size="40" />
        </AvatarWrapper>
        <div>
          {name && (
            <Typography customFont="bold" style={{ fontSize: '16px' }}>
              {name.length > 30 ? `${name.slice(0, 30)}...` : name}
            </Typography>
          )}
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <StyledGear
            className="icon"
            onClick={() => goToArtistSettings('/artist/profile')}
          />
        </div>
      </Flex>
    </Box>
  );
};

export default styled(ArtistSettingsWidget)`
  cursor: pointer;
  padding: 32px;
  font-fa
  height: max-content;
  border-radius: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  background-color: ${({ theme }) => theme.colors.midGray};
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.colors.midGray)};
  }
`;

const AvatarWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }
`;
